import { TGCTAs } from "@swiggy-private/cart-types";

export enum States {
    PRE_STATE = "PRE_STATE",
    POST_STATE = "POST_STATE",
}

export enum HalfcardVariants {
    DEFAULT = "DEFAULT",
    NEW = "NEW",
}

export interface TGLogoCTX {
    text: string;
    logo: string;
}

export interface CTA {
    link: string;
    type: string;
    text: string;
}

export interface BottomSheetData {
    logoCtx: TGLogoCTX;
    title: string;
    subtitles?: string[];
    ctas: CTA[];
    note?: string;
    attributeValues: Record<string, string>;
    designVariantId?: HalfcardVariants;
    isOneLite?: boolean;
}

export interface PreStateData {
    bottomSheetData: BottomSheetData;
    addSuperFromTGBottomsheet: (ctaText: string) => void;
    closeBottomSheet?: (ctaText: string) => void;
}

export interface PostStateData {
    headerText: string;
    logoCtx: TGLogoCTX;
    title: string;
    closeBottomSheet?: (ctaText: string) => void;
    duration?: number;
    subTitles?: string[];
    attributeValues?: Record<string, string>;
    cta?: TGCTAs;
    setIsM2CGratificationShown?: (v: boolean) => void;
}

export interface M2CSwiggyOneHalfCardProps {
    preStateData?: PreStateData;
    postStateData?: PostStateData;
    state?: States;
    root?: string;
    isOneLite?: boolean;
    onClose?: () => void;
}
export interface GratificationPopupLottieData {
    previousAmount: string;
    updatedAmount: string;
    heading: string;
    logo: string;
    billSubtext: string;
}

export interface PlanRemovalCardLottieData {
    previousAmount: string;
    updatedAmount: string;
    planType?: string;
}
